import { Row, Col } from "react-bootstrap";
import ApiUtils from "../../utils/api_utils";
import * as Assets from "./../../utils/svg_assets";
import "./style.scss";

const Reply = (props) => {
  const { data, handleClick = () => {} } = props;

  return (
    <Row className="mb-3">
      <Col xs={2} className=" mr-1">
        <img
          src={ApiUtils.validateImgUrl({ url: data.creator.image })}
          height="100%"
          className="circular-image"
          alt=""
        />
      </Col>
      <Col>
        <div className="fs-12 mb-1">
          <div className="d-flex align-items-center justify-content-between">
            <div>{data.creator.name}</div>
            <div>
              <img src={Assets.dot} onClick={() => handleClick(data)} />
            </div>
          </div>
        </div>
        <div className="fs-16 mb-2">{data.text}</div>
      </Col>
    </Row>
  );
};

export default Reply;
